import React, { useEffect, useState, useRef, useCallback } from 'react';
import clsx from 'clsx';
import styles from './ArticleProgressBar.module.scss';

interface Props {
  newThemeProgressBar?: boolean;
  sticky?: boolean;
}

const ArticleProgressBar = ({ newThemeProgressBar, sticky }: Props) => {
  const [progress, setProgress] = useState(0);
  const progressBarRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(() => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;

    const footer = document.querySelector('footer');
    const footerHeight = footer ? footer.offsetHeight : 0;

    const docHeight = document.documentElement.scrollHeight - footerHeight;

    const totalDocScrollLength = docHeight - windowHeight;
    const scrollPosition =
      totalDocScrollLength > 0 ? Math.floor((scrollTop / totalDocScrollLength) * 100) : 100;
    setProgress(scrollPosition);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <div className={clsx(styles.progressBarContainer, sticky && styles.sticky)}>
      <div
        ref={progressBarRef}
        className={clsx(styles.progressBar, newThemeProgressBar && styles.colorNew)}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default ArticleProgressBar;
